export const ADD_NOTIF_REF = 'ADD_NOTIF_REF'
export const UPDATE_NOTIF_REF = 'UPDATE_NOTIF_REF'
export const GET_NEXT_NOTIFS = 'GET_NEXT_NOTIFS'
export const GET_NOTIF_DATA_FROM_REFERENCE = 'GET_NOTIF_DATA_FROM_REFERENCE'
export const SET_NOTIF_DATA = 'SET_NOTIF_DATA'
export const UPDATE_NOTIFS_DATA = 'UPDATE_NOTIFS_DATA'
export const MERGE_NOTIF = 'MERGE_NOTIF'
export const MERGE_NOTIF_DATA = 'MERGE_NOTIF_DATA'
export const UPDATE_NOTIFS_DATES = 'UPDATE_NOTIFS_DATES'
export const UPDATE_NOTIFS_PUBLISHED_AT = 'UPDATE_NOTIFS_PUBLISHED_AT'
export const REFRESH_NOTIFS_PUBLISHED_AT = 'REFRESH_NOTIFS_PUBLISHED_AT'
export const SET_NOTIF_READ = 'SET_NOTIF_READ'
export const SAVE_NOTIF_READ = 'SAVE_NOTIF_READ'
export const DELETE_NOTIF = 'DELETE_NOTIF'
export const RESET_NOTIFS_ACTION = 'RESET_NOTIFS_ACTION'
export const RESET_NOTIFS = 'RESET_NOTIFS'
export const CALC_BADGE = 'CALC_BADGE'
export const SAVE_BADGE = 'SAVE_BADGE'



// WEBPACK FOOTER //
// ./src/store/actions/notificationQueries.js